<template>
    <div v-if="adContent != null" class="d-flex flex-column align-items-center justify-content-center ul-very-light-background ul-light-gray-panel ul-med-red-panel-top mr-2 mb-3 advertiser-panel"
         v-bind:data-advertiser="adContent.advertiserName">
        <div v-if="adContent.advertiserLogoUrl != null && adContent.advertiserLogoUrl != ''" class="flex-grow-1">
            <img v-bind:src="adContent.advertiserLogoUrl" class="mb-3" />
        </div>
        <div v-if="adContent.headingText != null && adContent.headingText != ''" class="mb-2 font-weight-bold">
            {{adContent.headingText}}
        </div>
        <div class="text-left mb-3 w-100">
            {{adContent.bodyText}}
        </div>
        <a v-for="externalLink of adContent.externalLinks" :key="externalLink.id"
            class="btn btn-light d-flex justify-content-start align-items-center advertiser-panel-link"
               v-bind:class="adContent.advertiserExternalLinkClass" @click="$store.dispatch('openUrl', { url: externalLink.linkUrl })">
                <span class="advertiser-panel-link-spacer" v-bind:class="externalLink.linkImageClass"></span>
                <span class="flex-grow-1">{{externalLink.linkText}}</span>
                <span class="advertiser-panel-link-spacer"></span>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'AdvertiserPanel',
        props: {
            adContent: {
                type: Object,
                default: () => {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>
</style>